import { FormField, IField } from 'modules/core/types';
import { useVendorFieldAndOptions } from 'hooks/useVendorFieldAndOptions';
import { LTV_TAXES_FEES_FILTER_OPTIONS, PREFERENCES_FIELD_NAMES, PREFERENCES_OPTION_VALUES } from 'modules/core/shared';
import { Dropdown } from 'modules/core/components';
import i18n from 'i18n';

import { useSettingsFieldsRulesForLender } from './useSettingsFieldsRulesForLender';

export const useLenderPreferencesFields = (): IField[] => {
  const { showVendorDropdown, enableLtvTaxesDropdown } = useSettingsFieldsRulesForLender();

  const { VENDOR_FIELD } = useVendorFieldAndOptions({
    optionsToExclude: [PREFERENCES_OPTION_VALUES.VENDOR_FILTER.CPO],
  });
  const lenderFields: IField[] = [];

  if (showVendorDropdown) {
    lenderFields.push(VENDOR_FIELD);
  }

  lenderFields.push({
    name: PREFERENCES_FIELD_NAMES.LTV_TAXES_FEES_FILTER,
    component: Dropdown as FormField,
    controlProps: {
      disabled: !enableLtvTaxesDropdown,
      options: LTV_TAXES_FEES_FILTER_OPTIONS,
    },
    isVerticalAlign: true,
    label: i18n.t('components.preferences.labels.ltvCalculation'),
  });

  return lenderFields;
};
